<template lang="pug">
div
  v-container(fluid v-if="isMounted" ref="folioDetailContainer")
    v-row(dense)
      v-col(cols="12")
        v-card(
          class="scrollable"
          style="overflow-y: scroll;"
          max-height="90vh")
          v-toolbar(
            height="40"
            color="green"
            dark)
            v-toolbar-title Información general del Documento
          v-row
            v-col(xs="12" sm="12" md="4")
              div(class="d-flex mb-2 flex-column")
                v-card-subtitle(class="my-auto text-h6 pb-1")
                  div Documento
                v-card-text(class="text--primary my-auto")
                  div {{ currentDocument.nombre }}

                v-card-subtitle(class="my-auto text-h6 pb-1")
                  div Entidad Emisora
                v-card-text(class="text--primary my-auto")
                  div {{ currentDocument.entidad_emisora }}

                v-card-subtitle(class="my-auto text-h6 pb-1")
                  div Fecha del documento
                v-card-text(class="text--primary my-auto")
                  div {{ currentDocument.fecha_documento }}

                v-card-subtitle(class="my-auto text-h6 pb-1")
                  div Tipo de documento
                v-card-text(class="text--primary my-auto")
                  div {{ currentDocument.tipo.nombre }}

                v-card-subtitle(class="my-auto text-h6 pb-1")
                  div Lugar de expedición
                v-card-text(class="text--primary my-auto")
                  div {{ currentDocument.municipio.nombre }} ({{ currentDocument.municipio.dpto_municipio.nombre }})

                v-card-subtitle(class="my-auto text-h6 pb-1")
                  div Folio(s) asociado(s) a este documento
                v-card-text(class="text--primary my-auto")
                  v-chip(
                    v-for="a in currentDocument.anotaciones_documento"
                    :key="a.folio_anotacion.id"
                    :to="`/folios/${a.folio_anotacion.id}/detail`"
                    class="ma-2 font-weight-bold"
                    color="primary")
                    | <b class="mr-1">{{ a.numero }}</b> -> {{a.folio_anotacion.numero_matricula}}
            v-col(xs="12" sm="12" md="8")
              embed(
                class="pdf-file"
                :src="`${staticUrl}${currentDocument.url}`"
                scrolling="no")
              //- v-container
                folio-visor(:folio-url="currentDocument.url")
  loading-content(v-else)
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FolioMainInfo from '@/components/folios/FolioMainInfo.vue';
import documentMixin from '@/mixins/documentMixin.js';
import LoadingContent from '@/components/ui/LoadingContent.vue';
import FolioVisor from '@/components/folios/FolioVisor.vue';
import { staticUrl } from '@/env';

export default {
  name: 'DocumentDetailView',

  components: {    
    FolioMainInfo,
    LoadingContent,
    FolioVisor,
  },

  mixins: [documentMixin],

  data: () => ({
    isMounted: false,
    staticUrl
  }),

  computed: {
    ...mapState('documents', ['currentDocument']),
    pdfUrl() {
      return `${staticUrl}${this.folioUrl}`
    }
  },

  async mounted() {
    const { documentId } = this.$route.params;
    await this.getDocumentDetail(documentId);
    this.isMounted = true;
  },

  methods: {
    ...mapActions('documents', ['getDocumentDetail']),
  }
};
</script>

<style scoped>
.pdf-file {
  width: 100%;
  height: 100vh;
}
</style>
